import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Dropdown, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import Loader from "../../components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../assets/css/brand.css";
import Swal from "sweetalert2";
import { Toaster } from "../../components/Toaster/Toster";
import Switch from "react-switch";
import ReactPaginate from "react-paginate";
import moment from "moment";
import DeleteWarningMdl from "../../components/common/DeleteWarningMdl";
import useDebounce from "../../components/common/Debounce";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import { FaArrowDown } from "react-icons/fa6";
import {
  deleteICAIUserApi,
  deleteMultiUsersApi,
  exportIcaiUserApi,
  exportUserListDataApi,
  getICAIUserApi,
  UpdateICAIUserStatus,
} from "../../../services/apis/ICAIUsersApi";
import { MdOutlineContentCopy } from "react-icons/md";
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
} from 'react-device-detect';
import { CreatelogActivityApi } from "../../../services/apis/IpAddress";
import { useSelector } from "react-redux";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { IoMdClose } from "react-icons/io";
import BtnLoader from "../../components/Loader/btnLoader";


const theadData = [
  { heading: "S.No.", value:"s.no.", sortingVale: "sno" },
  { heading: "Business Card Url", value:"business_card_url", sortingVale: "business_card_url" },
  { heading: "Member Id", value:"member_id", sortingVale: "member_id" },
  { heading: "User Type", value:"user_type", sortingVale: "user_type" },
  { heading: "Name", value:"member_name", sortingVale: "member_name" },
  // { heading: "User Name", sortingVale: "user_name" },
  // { heading: "Email", value:"email", sortingVale: "email" },
  { heading: "Mobile", value:"mobile", sortingVale: "mobile" },
  { heading: "Zone", value:"zone", sortingVale: "zone" },
  { heading: "Created At", value:"created_at", sortingVale: "created_at" },
  { heading: "Check For Delete", value:"check_for_delete", sortingVale: "check_for_delete" },
  { heading: "Status", value:"status", sortingVale: "status" },
  { heading: "Action", value:"action", sortingVale: "action" },
];

const excelHeadData = [
  { heading: "S.No.", value: "s.no.", sortingVale: "sno" },
  {
    heading: "Business Card Url",
    value: "business_card_url",
    sortingVale: "business_card_url",
  },
  { heading: "Member Id", value: "member_id", sortingVale: "alternate_member_id" },
  { heading: "User Type", value: "user_type", sortingVale: "user_type" },
  { heading: "Name", value: "member_name", sortingVale: "member_name" },
  //{heading: "User Name", sortingVale: "user_name" },
  { heading: "Email", value: "email", sortingVale: "email" },
  { heading: "Mobile", value: "mobile", sortingVale: "mobile" },
  {
    heading: "WhatsApp No",
    value: "whatsapp_number",
    sortingVale: "whatsapp_number",
  },
  { heading: "City", value: "city", sortingVale: "city" },
  { heading: "Zone", value: "zone", sortingVale: "zone" },
];


const ICAIUsers = () => {
  const navigate = useNavigate();
  const [sort, setSortata] = useState(10);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(
    document.querySelectorAll("#holidayList tbody tr")
  );
  const [updateCuisines, setUpdateBrands] = useState(false);
  const [icaiUserList, setIcaiUserList] = useState([]);
  const [originalBrandList, setOriginalBrandList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const activePag = useRef(0);
  const [test, settest] = useState(0);
  const [showDeleteMdl, setShowDeleteMdl] = useState(false);
  const [deleteTableDataId, setDeleteTableDataId] = useState("");
  const [multiDataDelete, setmultiDataDelete] = useState(false);
  const [selectedRowsId, setSelectedRowsId] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [exportBtnLoading, setExportBtnLoading] = useState(false);
  const [allUsers,setAllUsers]=useState([]);
   const [selectedDate, setSelectedDate] = useState({
      start:"",
      end:""
    });
    const [apiSelectedDate, setApiSelectedDate] = useState({
      start:"",
      end:""
    });
  const informationIp = useSelector((data)=>data?.ipAddressReducers?.ipAddressData);
  const user = useSelector((data)=>data?.userReducers?.user);

    const deviceType = {
      type: isMobile ? "Mobile" : isTablet ? "Tablet" : isDesktop ? "Desktop" : "Unknown",
      os: isAndroid ? "Android" : isIOS ? "iOS" : "Other"
    };

    const handleCallback = (start, end) => {
      setApiSelectedDate({start: start.format('YYYY-MM-DD'), end: end.format('YYYY-MM-DD') })
      setSelectedDate({ start: start.format('DD-MM-YYYY'), end: end.format('DD-MM-YYYY') });
    };

  // console.log("selectedRows",selectedRows)

  const debouncedSearchValue = useDebounce(searchInputValue, 500);

  const fetchIcaiUsers = async (sortValue) => {
    // Set loading to true when the API call starts
    setLoading(true);
    const usr_type = "ICAI";
    try {
      const res = await getICAIUserApi(
        currentPage,
        sort,
        sortValue,
        searchInputValue,
        usr_type,
        selectedZone,
        selectedDate
      );

      const limit = 15000;
        const resData = await getICAIUserApi(
          1,
          limit,
          sortValue,
          searchInputValue,
          usr_type,
          selectedZone,
          selectedDate
        );
        // const pageUsers = res?.data?.data?.users || [];
        // allUsers = resData?.data?.data?.users; 
        setAllUsers(resData?.data?.data?.users);

      setIcaiUserList(res?.data?.data);
      setOriginalBrandList(res?.data?.data);
      setUpdateBrands(false);
    } catch (error) {
      // Catch and handle errors
      console.error("Error fetching :", error);
      Toaster.error("Failed to load . Please try again.");
    } finally {
      // Always set loading to false when the API call is done (whether successful or failed)
      setLoading(false);
    }
  };
  // console.log("resssss",allUsers)

  useEffect(() => {
    fetchIcaiUsers();
  }, [updateCuisines, currentPage, sort, debouncedSearchValue, selectedZone,selectedDate]);

  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#holidayList tbody tr"));
  }, [test]);

  activePag.current === 0 && chageData(0, sort);

  function SotingData(name, ind) {
    // const sortedPeople = [...brandList?.brands];
    if (iconData.complete) {
      const sortValue = { value: name, type: "asc" };
      fetchIcaiUsers(sortValue);
    } else {
      const sortValue = { value: name, type: "dsc" };
      fetchIcaiUsers(sortValue);
    }
  }

  const handleEditIcaiUser = async (id, user_type) => {
    navigate(`/edituser/${id}`, { state: user_type });
  };

    const loggedActivity = async (logType) => {
      const data = {
        id: user?._id,
        ipAddress: informationIp?.query,
        lat: informationIp?.lat,
        long: informationIp?.lon,
        logType: logType,
        deviceType: JSON.stringify(deviceType),
        city: informationIp?.city,
        countryCode: informationIp?.countryCode,
        regionCode: informationIp?.region,
      };
      try {
        await CreatelogActivityApi(data);
      } catch (err) {
        console.log(err);
      }
    };

  const handleDeleteIcaiUser = (id) => {
    setDeleteTableDataId(id);
    setShowDeleteMdl(true);
  };

  const handleDeleteSubmit = async () => {
    try {
      const res = await deleteICAIUserApi(deleteTableDataId);
      if (res.status == 200) {
        loggedActivity("delete")
        Toaster.success(res?.data?.message); // Display success message
        fetchIcaiUsers();
        setDeleteTableDataId("");
        setShowDeleteMdl(false);
      } else {
        Toaster.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      Toaster.error(err?.response?.data?.message);
    }
  };

  const handleDeleteMultiIcaiUser = () => {
    if (selectedRowsId?.length > 0) {
      setShowDeleteMdl(true);
      setmultiDataDelete(true);
    } else {
      Toaster.warning("Please select member you want to delete.");
    }
  };

  const handleDeleteMultiUsers = async () => {
    const fdata = {
      users_to_delete: selectedRowsId,
    };
    try {
      const res = await deleteMultiUsersApi(fdata);
      // console.log("deleteres",res)
      if (res.status == 200) {
        Toaster.success(res?.data?.message); // Display success message
        loggedActivity("delete")
        fetchIcaiUsers();
        setSelectedRowsId([]);
        setShowDeleteMdl(false);
        setmultiDataDelete(false);
      } else {
        Toaster.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.log(err);
      Toaster.error(err?.response?.data?.message);
    }
  };

  const handleStatusChange = async (userId, currentStatus) => {
    const fdata = {
      status: !currentStatus,
    };
    try {
      const res = await UpdateICAIUserStatus(userId, fdata);
      // console.log("status response", res);
      if (res.status === 200) {
        Toaster.success(res?.data?.message); // Display success message
        fetchIcaiUsers();
      } else {
        Toaster.error(
          res?.data?.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.log(err);
        Toaster.error(err?.response?.data?.message);
    }
    // console.log("newStatus",newStatus)
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };


  const handleAddNewUser = () => {
    navigate("/addnewuser", { state: "ICAI" });
  };
  
  const convertToGeneralFormat = (number) => {
    if (number?.toString().includes("e")) {
      return Number(number).toLocaleString("fullwide", { useGrouping: false });
    }
    return number; // Return the number as is if it's not in scientific notation
  };

  const exportToExcel=()=>{
    const table = document.querySelector("table");
    const filteredData = allUsers?.filter((user) => !user.deleted);
    if (!filteredData || filteredData.length === 0) {
      alert("No valid data to export.");
      return;
    }
    const headers = excelHeadData
      ?.filter(
        (item) =>
          item?.value !== "s.no." &&
          item?.value !== "created_at" &&
          item?.value !== "check_for_delete" &&
          item?.value !== "status" &&
          item?.value !== "action"
      )
      ?.map((item) => `<th>${item.value}</th>`)
      ?.join("");
    const rows = filteredData
      ?.map((data, ind) => {
        const convertedNumber = convertToGeneralFormat(data?.mobile);
        const convertedWhatsAppNumber = convertToGeneralFormat(data?.whatsapp_number);
        return `
        <tr>
          <td>${data?.business_card_url}</td>
          <td>${data?.member_id}</td>
          <td>${data?.user_type}</td>
          <td>${data?.member_name}</td>
          <td>${data?.email ? data?.email :"-"}</td>
          <td>${convertedNumber}</td>
          <td>${convertedWhatsAppNumber}</td>
          <td>${data?.city ? data?.city :"-"}</td>
          <td>${data?.zone ? data?.zone : ""}</td>
        </tr>
      `;
      })
      .join("");

    const updatedTable = document.createElement("table");
    updatedTable.innerHTML = `
      <thead><tr>${headers}</tr></thead>
      <tbody>${rows}</tbody>
    `;

    const workbook = XLSX.utils.table_to_book(updatedTable, {
      sheet: "UserList",
    });
    XLSX.writeFile(workbook, "UserList.xlsx");
    loggedActivity("export")
  }

  // exportToExcel()
  const handleExportData =async () => {
   try{
     const res = await exportIcaiUserApi();
    if(res?.data?.success){
      exportToExcel();
      Toaster.success(res?.data?.message);       
    }
    }catch(err){
    //  console.log(err);
     Toaster.error(err?.response?.data?.message);
   }finally{
    setExportBtnLoading(false);
   }
  };

  const handleFileImport = (event) => {
    const file = event.target.files[0];
    if (file) {
      Papa.parse(file, {
        header: true, // Parse the first row as headers
        complete: (results) => {
          console.log("Parsed Data:", results.data);
        },
        error: (error) => {
          console.error("Error parsing CSV:", error);
        },
      });
    }
  };

  const handleCopyUrl = (url) => {
    if (!url) {
      Toaster.warning("Url not found");
      return;
    }
    navigator.clipboard
      .writeText(url)
      .then(() => {
        Toaster.success("Link copied to clipboard!");
      })
      .catch((err) => {
        // console.error("Failed to copy: ", err);
        Toaster.error("Failed to copy the link.");
      });
  };

  const getZoneBadgeClass = (zone) => {
    const normalizedZone = zone?.trim();
    switch (normalizedZone) {
      case "WRO":
        return "bg-blue"; // Blue
      case "SRO":
        return "bg-success"; // Green
      case "ERO":
        return "bg-danger"; // Red
      case "CRO":
        return "bg-warning"; // Yellow
      case "NRO":
        return "bg-info"; // Light Blue
      case "FRO":
        return "bg-dark"; // Dark Gray
      case "DUP":
        return "bg-secondary"; // Gray
      default:
        return "bg-light"; // Light Gray for unrecognized zones
    }
  };

  return (
    <>
      <ToastContainer />
      <DeleteWarningMdl
        title={"user"}
        showDeleteMdl={showDeleteMdl}
        setShowDeleteMdl={setShowDeleteMdl}
        setDeleteTableDataId={setDeleteTableDataId}
        handleDeleteSubmit={handleDeleteSubmit}
        multiDataDelete={multiDataDelete}
        setmultiDataDelete={setmultiDataDelete}
        handleDeleteMultiUsers={handleDeleteMultiUsers}
      />

      <Loader visible={loading} />
      <PageTitle
        activeMenu={`ICAI Users (${allUsers?.length})`}
        motherMenu={"Home"}
        motherMenuLink={"/dashboard"}
      />
      <Row>
        <Col lg={12}>
          <div className="card">
            <div className="card-header">
              {/* <h4 className="card-title">ICAI User List</h4> */}
              <div className="d-flex align-items-center gap-4">
              <div className="d-flex align-items-center gap-1">
                Filter :
                <Dropdown onSelect={(e) => setSelectedZone(e)}>
                  <Dropdown.Toggle
                    variant="primary"
                    size="sm"
                    className="mt-2 mb-2">
                    Zone : {selectedZone ? selectedZone : "All"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="">All</Dropdown.Item>
                    <Dropdown.Item eventKey="WRO">WRO</Dropdown.Item>
                    <Dropdown.Item eventKey="SRO">SRO</Dropdown.Item>
                    <Dropdown.Item eventKey="ERO">ERO</Dropdown.Item>
                    <Dropdown.Item eventKey="CRO">CRO</Dropdown.Item>
                    <Dropdown.Item eventKey="NRO">NRO</Dropdown.Item>
                    <Dropdown.Item eventKey="FRO">FRO</Dropdown.Item>
                    <Dropdown.Item eventKey="DUP">DUP</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                </div>

                <div className="d-flex align-items-center gap-1">
                  <p className="mb-0">Date Filter:</p>
                   <div className="example rangeDatePicker">
                     <DateRangePicker
                       initialSettings={{
                         startDate: moment(),
                         endDate: moment().add(1, 'days'),
                       }}
                       onCallback={handleCallback}>
                       <input type="text" 
                        value={
                         selectedDate?.start && selectedDate?.end
                          ? `${selectedDate?.start} - ${selectedDate?.end}`
                          : ""
                        }
                       placeholder="dd-mm-yyyy - dd-mm-yyyy"
                       className="form-control input-daterange-timepicker"/>
                     </DateRangePicker>
                   </div>
                    {
                     selectedDate?.start !== "" &&
                      <button className="btn p-0" onClick={()=>{setSelectedDate({start:"", end:""});
                       setApiSelectedDate({start:"", end:""})}}>
                     <IoMdClose size={18}/></button>
                    }
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row">
                <Button
                  variant="primary"
                  type="button"
                  className="mb-2 me-2"
                  onClick={handleAddNewUser} >
                  + Add New User
                </Button>

                <Button
                  variant="secondary"
                  type="button"
                  className="mb-2 me-2 secondary"
                  onClick={handleExportData}>
                  {exportBtnLoading && <BtnLoader/> }
                  Export
                </Button>

                {/* <div>
                  <label
                    className="btn secondary mb-2 me-2"
                    style={{ cursor: "pointer" }}>
                    <FaArrowDown /> Importing
                    <input
                      type="file"
                      accept=".csv,.txt,.json" // Restrict file types if needed
                      style={{ display: "none" }}
                      onChange={handleFileImport} // Pass the file selection handler
                    />
                  </label>
                </div> */}

                <Button
                  variant="dark"
                  type="button"
                  className="mb-2 me-2"
                  onClick={handleDeleteMultiIcaiUser}>
                  Delete Selected
                </Button>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div id="holidayList" className="dataTables_wrapper no-footer">
                  <div className="justify-content-between d-sm-flex">
                    <div className="dataTables_length">
                      <label className="d-flex align-items-center">
                        Show
                        <Dropdown className="search-drop">
                          <Dropdown.Toggle as="div" className="search-drop-btn">
                            {sort}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item onClick={() => {setSortata("2"); setCurrentPage(1)}}>
                              2
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {setSortata("5"); setCurrentPage(1)}}>
                              5
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {setSortata("10"); setCurrentPage(1)}}>
                              10
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {setSortata("15"); setCurrentPage(1)}}>
                              15
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => {setSortata("20"); setCurrentPage(1)}}>
                              20
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        Entries
                      </label>
                    </div>
                    <div className="dataTables_filter">
                      <label>
                        Search :
                        <input
                          type="search"
                          className=""
                          placeholder=""
                          onChange={(e) => setSearchInputValue(e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                {icaiUserList?.users?.length > 0 ?
                  <table
                    id="example4"
                    className="display dataTable no-footer w-100">
                    <thead>
                      <tr>
                        {theadData?.map((item, ind) => {
                          return (
                            <th
                              key={ind}
                              onClick={() => {
                                SotingData(item?.sortingVale, ind);
                                setIconDate((prevState) => ({
                                  complete: !prevState.complete,
                                  ind: ind,
                                }));
                              }}>
                              {item.heading}
                              <span>
                                {ind !== iconData.ind && (
                                  <i
                                    className="fa fa-sort ms-2 fs-12"
                                    style={{ opacity: "0.3" }}
                                  />
                                )}
                                {ind === iconData.ind &&
                                  (iconData.complete ? (
                                    <i
                                      className="fa fa-arrow-down ms-2 fs-12"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ) : (
                                    <i
                                      className="fa fa-arrow-up ms-2 fs-12"
                                      style={{ opacity: "0.7" }}
                                    />
                                  ))}
                              </span>
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {icaiUserList?.users?.map((data, ind) => (
                        <tr key={ind}>
                          <td>
                          <strong>{(currentPage - 1) * sort + ind + 1}</strong>
                            {/* <strong>{ind + 1}</strong> */}
                          </td>
                          <td>
                          <div className="d-flex align-items-center">
                            <Link
                              target="_blank"
                              to={
                                data?.business_card_url
                                  ? data?.business_card_url
                                  : ""
                              }>
                              {data?.business_card_url}
                            </Link>
                            <button
                              onClick={() =>
                                handleCopyUrl(data?.business_card_url)}
                              className="link-copy-btn ms-2">
                              <MdOutlineContentCopy />
                            </button>
                            </div>
                          </td>
                          <td>{data?.member_id}</td>
                          <td>{data?.user_type}</td>
                          <td className="">
                            <Link to={`/userdetail/${data?._id}`}>
                              {data?.member_name}
                            </Link>
                          </td>
                          {/* <td><Link to="/userdetail">{data?.username}</Link></td> */}
                          {/* <td>{data?.email}</td> */}
                          <td>{data?.mobile}</td>
                          <td>
                            <span
                              className={`badge light ${getZoneBadgeClass(
                                data?.zone
                              )}`}>
                              {data?.zone}
                            </span>
                          </td>

                          {/* created_at */}
                          <td>
                            {moment(data?.created_at).format(
                              "DD MMM YYYY, h:mm:ss a"
                            )}
                          </td>
                          <td className="">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={selectedRowsId?.includes(data?._id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedRowsId((prev) => [
                                    ...prev,
                                    data?._id,
                                  ]);
                                } else {
                                  setSelectedRowsId((prev) =>
                                    prev?.filter((id) => id !== data?._id)
                                  );
                                }
                              }}
                            />
                          </td>

                          <td>
                            <Switch
                              checked={data?.status}
                              onChange={() =>
                                handleStatusChange(data?._id, data?.status)
                              }
                              offColor="#f0f3ff"
                              onColor="#475cff"
                              offHandleColor="#6a73fa"
                              onHandleColor="#fff"
                              uncheckedIcon={false}
                              checkedIcon={false}
                              width={40}
                              height={20}
                            />
                          </td>
                          <td>
                            <div className="d-flex">
                            <Link
                              to={`/userdetail/${data?._id}`}
                              className="btn btn-xs sharp btn-secondary me-1">
                              <i class="fa-solid fa-eye"></i>
                            </Link>

                            <button
                              className="btn btn-xs sharp secondary me-1"
                              onClick={() =>
                                handleEditIcaiUser(data?._id, data?.user_type)
                              }>
                              <i className="fa fa-pencil" />
                            </button>

                            <button
                              className="btn btn-xs sharp btn-danger"
                              onClick={() => handleDeleteIcaiUser(data?._id)}>
                              <i className="fa fa-trash" />
                            </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  :
                  <div>
                   <h4 className="text-danger text-center">No Record Found</h4>
                  </div>
                  }
                  <div>
                    {/* {brandList?.data?.length < brandList?.total && ( */}
                    <div className="d-sm-flex text-center justify-content-end align-items-center mt-3">
                      <div className="pagination-container">
                        <ReactPaginate
                          pageCount={Math.ceil(
                            icaiUserList?.total / icaiUserList?.rowPerPage
                          )}
                          pageRangeDisplayed={1}
                          marginPagesDisplayed={2}
                          onPageChange={handlePageClick}
                          containerClassName="pagination"
                          activeClassName="selected"
                          disabledClassName="disabled"
                        />
                      </div>
                    </div>
                    {/* )} */}
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ICAIUsers;
